import type { UseQueryResult } from "@edreamsodigeo/frontend-api-client";
import { useQuery } from "@edreamsodigeo/frontend-api-client";

import type {
  GetPriceBreakdownPriceSummaryQuery,
  GetPriceBreakdownPriceSummaryQueryVariables,
} from "~/generated/graphql";
import { useShoppingInfo } from "~/clientState/hooks/useShoppingInfo";
import { PRICE_BREAKDOWN_PRICE_SUMMARY } from "~/clientState/providers/operations/priceBreakdownPriceSummary";

export const useGetCartPriceBreakDownItems = (): {
  cartPriceBreakDownItems: GetPriceBreakdownPriceSummaryQuery["getCartPriceBreakDown"]["items"];
  loading: boolean;
  fetching: boolean;
} => {
  const shoppingInfo = useShoppingInfo();
  const {
    data,
    loading,
    fetching,
  }: UseQueryResult<
    GetPriceBreakdownPriceSummaryQuery,
    GetPriceBreakdownPriceSummaryQueryVariables
  > = useQuery<
    GetPriceBreakdownPriceSummaryQuery,
    GetPriceBreakdownPriceSummaryQueryVariables
  >(PRICE_BREAKDOWN_PRICE_SUMMARY, {
    variables: {
      request: {
        shoppingInfo,
      },
    },
  });

  return {
    cartPriceBreakDownItems: data?.getCartPriceBreakDown?.items ?? null,
    loading,
    fetching,
  };
};

export default useGetCartPriceBreakDownItems;
